export default __webpack_public_path__ + "media/images/react_icons/google_store_large-774e48cb9454e63c14654653da500129.png";